module.exports = __webpack_public_path__ + "static/media/jcb.154bf206.svg";